/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Marin POST /user/location — update location ({@link UPDATE_LOCATION_REQUESTED}).
 *
 * @file UpdateLocationService.js
 * @author Gladson Samuel S
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  UPDATE_LOCATION_REQUESTED,
  UPDATE_LOCATION_COMPLETED,
  UPDATE_LOCATION_FAILED,
  HTTP_REQUEST_METHODS
} from '../../../common/constants';
import env from '../../../common/env';

export default class UpdateLocationService extends BaseService {
  constructor() {
    super(UPDATE_LOCATION_REQUESTED, 'updateLocationStatus');
  }

  /** POST /user/location */
  handleEvent(eventName, eventData = {}) {
    const {
      payload,
      method = HTTP_REQUEST_METHODS.PUT
    } = eventData;

    const headers = {
      'X-TenantKey': env.TENANT_KEY_ETEXT,
      'X-TenantId': env.TENANT_ID_ETEXT
    };

    if (method === HTTP_REQUEST_METHODS.PUT) {
      return this.getClient('spectrumV4').put('/user/location', payload, { headers });
    }

    return this.getClient('spectrumV4').post('/user/location', payload, { headers });
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { data } = response;
    const { callback } = eventData;

    Framework.getEventManager().publish(UPDATE_LOCATION_COMPLETED, data);

    if (typeof callback === 'function') {
      callback(data);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error, eventData = {}) {
    const { callback } = eventData;

    Framework.getEventManager().publish(UPDATE_LOCATION_FAILED, error);

    if (typeof callback === 'function') {
      callback(null, error);
    }
  }
}
